import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMicrowaves } from 'app/mocks/data/machines/microwaves'

import { formDataToData } from 'app/utils/app/requests'
import { api } from 'app/utils/constants'

import { Microwave, MicrowavePayload } from 'app/types/machines/microwave'

export const updateMicrowave = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.microwaves.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params
        const data = await request.formData()

        const payload = formDataToData(data)
        const payloadParsed = MicrowavePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const microwaveFound = allMicrowaves.find(
            (machine) => machine.id.toString() === id,
        )

        // Not found
        if (!microwaveFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Microwave>({
            ...microwaveFound,
            ...data,
            site: microwaveFound.site,
        })
    },
)
